 $(function(){
     if (document.getElementById('scene')) {
         const scene = document.getElementById('scene');
         const parallaxInstance = new Parallax(scene);
     }
});
